<template>
  <label :for="item.field" class="relative block text-sm font-medium uppercase text-primary-800" @click="$emit('sticky')">
    <span v-if="item.required" class="el_1_da1a5dd607a80d73fb51dc5b84c1fa12 inline mr-1 text-sm text-red-400">*</span>
    {{ item.name }}
    <div class="el_2_da1a5dd607a80d73fb51dc5b84c1fa12 absolute top-0 right-0">
      <KeyIcon v-if="item.unique" class="inline w-4 h-4 ml-2 mr-1 text-red-500" />
      <InformationCircleIcon
        v-if="item.popover" class="inline-block w-4 h-4 mb-1 ml-1 cursor-pointer"
        @click="show_help = !show_help"
      />
    </div>
  </label>
  <div class="el_3_da1a5dd607a80d73fb51dc5b84c1fa12 relative flex justify-between space-x-4 mt-1 rounded-md shadow-sm">
    <div class="flex-1">
      <select
        :id="item.field" v-model="selected" multiple tabindex="0" :name="item.field"
        :disabled="item.loading || item.disabled || item.lock_edits"
        :readonly="item.sticky === true"
        class="block w-full h-72 py-2 pl-3 pr-10  text-base border-gray-200 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500 disabled:bg-gray-200"
        :class="[error ? 'border-red-500' : '' , item.sticky ? 'bg-yellow-50' : '']"
        @change="convertToModelValue"
      >
        <ChevronDownIcon
          :class="open ? 'transform rotate-180' : ''"
          class="absolute w-5 h-5 font-extrabold text-gray-600 cursor-pointer right-3 top-3"
        />
        <option />
        <option v-for="i in options" :key="i" :value="i">
          {{ i }}
        </option>
      </select>
    </div>
    <div class="flex-1 whitespace-pre-line bg-white rounded-md border-gray-400 shadow-sm p-2">
      <div class="text-primary-700 uppercase text-sm">
        Selected:
      </div>
      {{ modelValue }}
    </div>
  </div>
  <div
    v-if="show_help && item.popover"
    class="el_4_da1a5dd607a80d73fb51dc5b84c1fa12 absolute left-0 z-40 p-2 mt-1 border rounded-lg shadow-lg top-16 text-primary-700 bg-primary-100 border-primary-300"
    @click="show_help = false"
  >
    <InformationCircleIcon class="inline-block w-6 h-6 mr-1" /> {{ item.popover }}
  </div>
</template>

<script>
import { InformationCircleIcon, KeyIcon, ChevronDownIcon } from "@heroicons/vue/outline";

export default {
  components: {
    InformationCircleIcon,
    KeyIcon,
    ChevronDownIcon,
  },
  props: {
    item: Object,
    error: String,
    modelValue: {
      type: [String, Number, Boolean],
      default: "",
    },
  },
  emits: { "update:modelValue": null },
  data() {
    return {
      selected: [],
      options: [],
      show_help: false,
      open: false,
    };
  },
  created() { 
    try {
      this.options = JSON.parse(this.item.combo_array);
    } catch (e) {
      this.options = [];
      alert("Error parsing combo_array for field "+this.item.field+". Verify configuration")
    }

    if (this.modelValue)
    this.selected = this.modelValue.split("\n");
  },
  methods: {
    convertToModelValue() {
      // array to string with \n seperator
      this.$emit("update:modelValue", this.selected.join("\n"));
    },
  },
};
</script>
